import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Profile = () => {
  return (
    <div className={cx('commonBox')}>
      {/* 이미지 슬라이드 제목 */}
      <div className={cx('mainDesc')}>
        <div className={cx('icon', 'folder')} />
        <span className={cx('text')}>어디 잘 쓴 이력서 하나 없냐고요?</span>
        <span className={cx('desc')}>여기 15개나 있습니다!</span>
        <div className={cx('star')} />
      </div>
      <div className={cx('basicTitle')}>
        <p className={cx('subTitle')}>실제 합격자의 프로필과 합격자&인담자의 꿀팁으로</p>
        <p className={cx('mainTitle')}>인사담당자의 눈길을 사로잡는 프로필을 완성해보세요!</p>
      </div>
    </div>
  );
};

export default Profile;
